const jcsjgl = [{
    path: 'jcsjgk_qyjcxx',
    name: 'jcsjgk_qyjcxx',
    component: () =>
        import ("@/components/jcsjgl/qyjcxx"),
    meta: { title: '企业基础信息', requireAuth: true, keepAlive: true, permission: true },
}]
export default jcsjgl


// WEBPACK FOOTER //
// ./src/router/jcsjgl.js